import {
  asyncRoutes,
  constantRoutes
} from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  console.log('vuex permission hasPermission', roles, route)
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

function hasPermissionNew(menuIds, route) {
  return menuIds.some(menuId => +route.meta.id === menuId)
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = {
      ...route
    }
    if (hasPermission(roles, tmp)) {
      console.log('vuex permission filterAsyncRoutes', roles, tmp)
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  // 最后添加404
  res.push({
    path: '*',
    redirect: '/404',
    hidden: true
  })

  return res
}

export function filterAsyncRoutesNew(routes, menuIds) {
  const res = []
  routes.forEach(route => {
    const tmp = {
      ...route
    }
    if (hasPermissionNew(menuIds, tmp)) {
      console.log('vuex permission filterAsyncRoutesNew', menuIds, tmp)
      if (tmp.children) {
        tmp.children = filterAsyncRoutesNew(tmp.children, menuIds)
      }
      res.push(tmp)
    }
  })
  // 最后添加404
  res.push({
    path: '*',
    redirect: '/404',
    hidden: true
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({
    commit
  }, roles) {
    console.log('vuex permission generateRoutes')
    return new Promise(resolve => {
      const rolseArr = roles.split(',')
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, rolseArr)
      console.log('vuex permission filterAsyncRoutes result', accessedRoutes)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  generateRoutesNew({
    commit
  }, params) {
    console.log('vuex permission generatRoutesNew')
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutesNew(params.asyncRoutes, params.menuIds)
      console.log('vuex permission filterAsyncRoutes result', accessedRoutes)

      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
